import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme: any) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    errors: {
      color: '#C83C5D',
      marginTop: 8,
      fontSize: 16, 
      fontFamily: 'Montserrat',
    },
    disable: {
      '& span': {
        color: `${theme.custom.colors.borderGrey} !important`,
      },
      '& input': {
        border: `1px solid ${theme.custom.colors.borderGrey} !important`,
        color: `${theme.custom.colors.borderGrey} !important`,
      },
    },
    containerErr: {
      '& label': {
        color: `${theme.custom.colors.error1} !important`,
      },
      '& span': {
        color: `${theme.custom.colors.error1} !important`,
      },
      '& input': {
        border: `1px solid ${theme.custom.colors.error1} !important`,
        color: `${theme.custom.colors.error1} !important`,
      },
    },
    textLabel: {
      font: theme.custom.font.label,
      marginRight: 9,
      color: theme.custom.colors.primary,
    },
    textOptional: {
      font: theme.custom.font.label,
    },
    content: {
      width: '100%',
      position: 'relative',
      alignItems: 'center',
      display: 'flex',
    },
    priceSymbol: {
      position: 'absolute',
      font: theme.custom.font.priceSymbol,
      left: '8px',
      marginTop: '-2px',
      color: '#D2D2D2',
    },
    input: {
      width: '100%',
      border: `1px solid ${theme.custom.colors.primary}`,
      height: '32px',
      borderRadius: '20px',
      padding: '0px 16px',
      font: theme.custom.font.placeholder,
      '&::placeholder': {
        font: theme.custom.font.placeholder,
        color: theme.custom.colors.placeholder,
      },
      '&:focus': {
        outline: 'none',
      },
      '&::-webkit-outer-spin-button, &::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        display: 'none',
      },
    },
    tooltip: {
      background: '#000',
      padding: `10px !important`,
      font: 'normal normal 400 13px/24px Public-Sans !important',
      borderRadius: 20
    },
    popupTooltip: {
      color: '#111',
    },
  };
});

export default useStyles;
